/**
 * 回傳自訂週一到週日
 * @param {number} weekOffset - 從本週開始算，第幾週 (1=下週, 0=本週)
 * @returns {{ start: Date, end: Date }}
 */
export const getWeekRange = (weekOffset = 1) => {
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const day = today.getDay(); // 星期 (0=週日, 1=週一, ...)
  const nextMonday = new Date(today);

  const daysUntilNextMonday = ((8 - day) % 7) || 7;
  nextMonday.setDate(today.getDate() + daysUntilNextMonday + (weekOffset - 1) * 7);

  const nextSunday = new Date(nextMonday);
  nextSunday.setDate(nextMonday.getDate() + 6);

  return { start: nextMonday, end: nextSunday };
};

/**
 * 回傳本月起始與結束
 * @returns {{ start: Date, end: Date }}
 */
export const getMonthRange = () => {
  const today = new Date();

  const start = new Date(today.getFullYear(), today.getMonth(), 1);
  start.setHours(0, 0, 0, 0);

  const end = new Date(today.getFullYear(), today.getMonth() + 1, 0);
  end.setHours(23, 59, 59, 999);

  return { start, end };
};

/**
 * 回傳本年起始與結束
 * @returns {{ start: Date, end: Date }}
 */
export const getYearRange = () => {
  const today = new Date();

  const start = new Date(today.getFullYear(), 0, 1);
  start.setHours(0, 0, 0, 0);

  const end = new Date(today.getFullYear(), 11, 31);
  end.setHours(23, 59, 59, 999);

  return { start, end };
};
